define((require) => {
    "use strict";

    const Configuration = require("shared/services/Configuration");

    const ImprovedView  = require("zbone/ImprovedView");
    const template      = require("ui/viewer/SceneThumbnailViewer.tpl");
    const ImprovedModel = require("shared/zbone/ImprovedModel");
    const $             = require("jquery");
    const ExperienceThumbnailViewer = require("ui/viewer/ExperienceThumbnailViewer");
    const UUIDGenerator    = require("ui/experience/widgets/UUIDGenerator");
    /**
     * View model for the scene thumbnail.
     *
     * @class ExperienceThumbnailImageViewModel
     * @constructor
     */
    const ExperienceThumbnailImageViewModel = ImprovedModel.extend("ExperienceThumbnailImageViewModel", {

        _experience: null,
        _maxDimensions: null,
        _isPushed: null,
        content: null,

        url() {
            let constructedUrl = ""; // default to nothing!  This will cause a fail on the fetch
            // which is what we will want if we can't form a url.

            const isPushed = this.get("_isPushed");

            // For some reason if we didn't push the pushedAt value comes back as zero even
            // if it doesn't exist in mongo! $
            if (isPushed) {
                const experience = this.get("_experience");
                const pushedAtEpochTimeMs = experience.get("pushedAt");
                const pushedAtEpochTime = (pushedAtEpochTimeMs / 1000).toFixed(0);
                const experienceId = experience.get("id");

                const experienceWidth = experience.get("width");
                const experienceHeight = experience.get("height");

                const scaledDimensions = experience.getDimensions(this.get("_maxDimensions"));
                const thumbnailWidth = scaledDimensions.width;
                const thumbnailHeight = scaledDimensions.height;
                const snapshotDelaySeconds = 0;

                const traceUUID = UUIDGenerator.createUUID();

                constructedUrl = `${Configuration.experienceUrl2PngBaseUrl}?`;
                constructedUrl += `&experienceId=${experienceId}`;
                constructedUrl += `&pushedAtEpochTime=${pushedAtEpochTime}`;
                constructedUrl += `&experienceWidth=${experienceWidth}`;
                constructedUrl += `&experienceHeight=${experienceHeight}`;
                constructedUrl += `&thumbnailWidth=${thumbnailWidth}`;
                constructedUrl += `&thumbnailHeight=${thumbnailHeight}`;
                constructedUrl += `&maintainAspectRatio=true`;
                constructedUrl += `&traceUUID=${traceUUID}`;

                // TODO: The snapshot delay needs to have to things to work properly.
                // (1) Cloudinary needs to figure out the proper way to set this value
                //     in the Java sdk.  The usage in ms-experiences server does not work
                //     like they say.  Passing in this value does create a param but its wrong (but harmless)
                // (2) Somewhere in the experience we need to find a timing for an animation to complete
                //     and use that value to calc the number of seconds for url2png to wait before
                //     snapping an image!
                if (snapshotDelaySeconds > 0) {
                    constructedUrl += `&snapshotDelaySeconds=${snapshotDelaySeconds}`;
                }
            }

            return constructedUrl;
        },
        // call original Backbone.Model#fetch with `dataType` equal `text` for $.ajax
        // this is a stack exchange special for dealing with raw text return objects
        // The only difference is the added "return" below because the result from our
        // overridden method is supposed to be a promise object.
        // https://stackoverflow.com/questions/22567027/backbone-model-is-plain-text-file-how-to-fetch
        fetch(options) {
            // eslint-disable-next-line no-undef
            options = _.extend(options || {}, {
                dataType: "text"
            });
            return this.constructor.__super__.fetch.call(this, options);
        },
        // store response in content attribute
        parse(response) {
            return {content: response};
        },
        defaults: {
            id: "",
            content: ""
        }
    });

    /**
     * A scene thumbnail "viewer". Renders a scene with some defined maximum size.
     *
     * @class ExperienceThumbnailImageViewer
     * @constructor
     *
     * @cfg {ExperienceModel} experience The parent experience.
     * @cfg {Object} [maxDimensions] Optional max dimensions to scale the viewer to. If specified, must contain width, height, or both.
     */
    return ImprovedView.extend({

        className: "scene-thumbnail experience-container",


        template,

        ui: {
            sceneWrapper: ".scene-wrapper-inner",
            sceneWrapperOuter: ".scene-wrapper-outer"
        },

        _experience: null,
        _sceneZeroModel: null, // used to pass to the experienceThumbnailViewer should this viewer fail
        _isPushed: false,
        _showStaticScenes: null, // used to pass to the experienceThumbnailViewer should this viewer fail
        _maxDimensions: null,
        _isThumbnailsNativeContentIntegrationsEnabled: null, // if enabled and we fail to then use this viewer

        initialize() {
            this._experience = this.options.experience;
            this._isPushed = (this._experience.get("pushedAt") > 0);
            this._sceneZeroModel = this.options.model;
            this._showStaticScenes = this.options.showStaticScenes;
            this._maxDimensions = this.options.maxDimensions;
            this._isThumbnailsNativeContentIntegrationsEnabled = this.options.isThumbnailsNativeContentIntegrationsEnabled;
        },

        /**
         * Used only when we fail for some reason talking to ms-experiences to get a singed url2png url.
         * This viewer generates static html from an experience using cnc if the experience was pushed AND
         * the integration type "" is enabled for this company.  If it wasn't
         * pushed then we fall back further to putting a message of "Thumbnail Unavailable" in place of the thumbnail.
         * @private
         */
        _fallbackThumbnail() {
            if (this._isPushed && this._isThumbnailsNativeContentIntegrationsEnabled) {
                const experienceThumbnailViewer = new ExperienceThumbnailViewer({
                    model: this._sceneZeroModel,
                    experience: this._experience,
                    maxDimensions: this._maxDimensions,
                    showStaticScenes: this._showStaticScenes
                });

                this.$el.find(this.ui.sceneWrapper).append(experienceThumbnailViewer.render().$el);
            } else {
                // old default thumbnail code.
                const defaultThumbnail = document.createElement("DIV");
                defaultThumbnail.innerHTML += "Thumbnail <br> Unavailable";
                defaultThumbnail.style.cssText = "border: none;text-align: center;color: @grey04;font-size: 18px;font-weight: 800; cursor: default";
                this.$el.find(this.ui.sceneWrapper).append(defaultThumbnail);
            }
        },

        onRender() {
            if (this.isClosed) {
                return;
            }

            const self = this;

            // only attempt to render an image if the experience was pushed!
            if (self._isPushed) {
                const model = new ExperienceThumbnailImageViewModel({
                    _experience: self._experience,
                    _maxDimensions: self._maxDimensions,
                    _isPushed: self._isPushed
                });

                model.fetch({silent: true}).then(() => {
                    const content = model.get("content");

                    if (content === "") {
                        self._fallbackThumbnail();
                    } else {
                        const sceneWrapperOuterElement = self.$el.find(self.ui.sceneWrapperOuter);
                        $(sceneWrapperOuterElement).css({
                            overflow: "hidden"
                        });

                        const scenewrapperElement = self.$el.find(self.ui.sceneWrapper);

                        scenewrapperElement.append(`<img src=${content} class="scene-dashboard-thumbnail"/>`);
                    }
                }).fail(() => {
                    self._fallbackThumbnail();
                });
            } else {
                self._fallbackThumbnail();
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/viewer/ExperienceThumbnailImageViewer.js